import { Fragment, type ReactNode } from "react";
import styles from "./index.module.scss";

type MessageWithLinksProps = {
  text: string;
  className?: string;
};

const MARKDOWN_LINK_PATTERN = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;

/**
 * `[ラベル](URL)` 形式の Markdown リンクをアンカーに変換してレンダリングする。
 * - `http://` / `https://` のみ許可（XSS 対策で `javascript:` 等を排除）
 * - パターン外のテキストはエスケープせずそのまま表示（React の自動エスケープに委譲）
 * - 対象外の Markdown 記法（強調・見出し等）は扱わない
 */
export const MessageWithLinks = ({ text, className }: MessageWithLinksProps) => {
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;

  MARKDOWN_LINK_PATTERN.lastIndex = 0;
  let match: RegExpExecArray | null = MARKDOWN_LINK_PATTERN.exec(text);
  while (match !== null) {
    if (match.index > lastIndex) {
      parts.push(<Fragment key={key++}>{text.slice(lastIndex, match.index)}</Fragment>);
    }
    const [, label, url] = match;
    parts.push(
      <a
        key={key++}
        href={url}
        className={styles["link"]}
        target="_blank"
        rel="noopener noreferrer"
      >
        {label}
      </a>,
    );
    lastIndex = MARKDOWN_LINK_PATTERN.lastIndex;
    match = MARKDOWN_LINK_PATTERN.exec(text);
  }
  if (lastIndex < text.length) {
    parts.push(<Fragment key={key++}>{text.slice(lastIndex)}</Fragment>);
  }

  return <span className={className}>{parts}</span>;
};
